// extracted by mini-css-extract-plugin
export var orderSummary = "_tb-0";
export var showMoreLessButton = "_tb-1";